/*global ga*/
/* @flow */

import PlatopulseSettings from "platopulse/lib/settings";

import { DEBUG } from "platopulse/lib/debug";


// Simple module for in-app analytics.  Currently sends data to GA but could be extended to anything else.
const PlatopulseAnalytics = {
    // track a pageview (a.k.a. route change)
    trackPageView: function(url: string) {
        if (url) {
            // scrub query builder urls to remove serialized json queries from path
            url = (url.lastIndexOf('/q/', 0) === 0) ? '/q/' : url;

            const { tag } = PlatopulseSettings.get('version');

            // $FlowFixMe
            ga('set', 'dimension1', tag);
            ga('set', 'page', url);
            ga('send', 'pageview', url);
        }
    },

    // track an event
    trackEvent: function(category: string, action?: string, label?: string|number|boolean, value?: number) {
        const { tag } = PlatopulseSettings.get('version');

        // category & action are required, rest are optional
        if (category && action) {
            // $FlowFixMe
            ga('set', 'dimension1', tag);
            ga('send', 'event', category, action, label, value);
        }
        if (DEBUG) {
            console.log("trackEvent", { category, action, label, value });
        }
    }
}

export default PlatopulseAnalytics;


export function registerAnalyticsClickListener() {
    // $FlowFixMe
    document.body.addEventListener("click", function(e) {
        var node = e.target;

        // check the target and all parent elements
        while (node) {
            if (node.dataset && node.dataset.platopulseEvent) {
                // we expect our event to be a semicolon delimited string
                const parts = node.dataset.platopulseEvent.split(";").map(p => p.trim());
                PlatopulseAnalytics.trackEvent(...parts);
            }
            node = node.parentNode;
        }
    }, true);
}



// WEBPACK FOOTER //
// ./lib/analytics.js